import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PUBLIC_API_REQUEST } from './public-api-request.context';

/**
 * Edulog's client secret must never ship in the browser bundle, so the OIDC
 * library's authorization code request is sent to the backend instead, which
 * adds the secret and forwards it to Edulog's token endpoint.
 */
@Injectable()
export class EdulogTokenInterceptor implements HttpInterceptor {
  private readonly edulogTokenUrl = `${environment.edulog.authority}/protocol/openid-connect/token`;
  private readonly backendTokenUrl = `${environment.apiBaseUrl}/v1/users/auth/edulog/token`;

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (req.method !== 'POST' || req.url !== this.edulogTokenUrl) {
      return next.handle(req);
    }
    return next.handle(
      req.clone({
        url: this.backendTokenUrl,
        context: req.context.set(PUBLIC_API_REQUEST, true),
      })
    );
  }
}
